import { WidgetContainer } from './components/containers';
import { WidgetCard } from './components/widget-card';
import { WidgetWithTabs } from './components/widget-with-tabs';
import { WidgetClockProvider } from './context-clock';
import { ContextMarkAttendanceProvider } from './context-mark-attendance';
import { useWidgetSize } from './hooks/use-widget-size';
import { useAddI18nLocales } from './i18n';
import { getCurrentTimeZone } from './utils';

const timeZone = getCurrentTimeZone();

export type TWidgetProps = {
  onMarkRegistered?: () => void;
  mode: 'widget' | 'card';
};
/** Core attendance widget — portable, no header/tabs.
 * Three responsive layouts: S (vertical), M (2-column), L (3-column).
 * Wrapped by WidgetWithActions for page integration with tabs + header. */
export const Widget = ({ mode }: TWidgetProps) => {
  useAddI18nLocales();

  const size = useWidgetSize();

  const widget = (
    <WidgetClockProvider timeZone={timeZone}>
      <ContextMarkAttendanceProvider timeZone={timeZone}>
        <WidgetCard size={size} timeZone={timeZone} mode={mode} />
      </ContextMarkAttendanceProvider>
    </WidgetClockProvider>
  );

  if (mode === 'card') {
    return <WidgetContainer mode="card">{widget}</WidgetContainer>;
  }

  return (
    <WidgetWithTabs timeZone={timeZone} size={size}>
      {widget}
    </WidgetWithTabs>
  );
};
